// @flow

import type {Action} from '../../types';
import type {FeaturesStore} from '../types';

import {SET_DISPUTE_FEATURES} from '../actions/features';

const initialState: FeaturesStore = {
  disputeFeatures: []
};

export default (state: FeaturesStore = initialState, action: Action) => {
  switch (action.type) {
    case SET_DISPUTE_FEATURES:
      return {
        ...state,
        disputeFeatures: action.payload
      };
    default:
      return state;
  }
};
